import createActions from 'utils/redux/createActions'

export default createActions([
  'TOOGLE_LEFT_NAV',
  'CLOSE_LEFT_NAV',
  'TOOGLE_FILTERS_PANEL',
  'SCROLL'
])



// WEBPACK FOOTER //
// ./src/actions/actionbar.js